import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import ModuleTour from '../components/Training/ModuleTour';

function Customers() {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [pagination, setPagination] = useState({ page: 1, limit: 20, total: 0, totalPages: 0 });
  const [newCustomer, setNewCustomer] = useState({
    first_name: '',
    last_name: '',
    phone: '',
    email: '',
    gender: 'unknown',
    birth_date: '',
    city: '',
    notes: '',
    source: 'walk_in'
  });
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [uploadingDocs, setUploadingDocs] = useState(false);
  const fileInputRef = useRef(null);

  useEffect(() => {
    fetchCustomers();
  }, [pagination.page, search]);

  const fetchCustomers = async () => {
    try {
      const token = localStorage.getItem('crm_token');
      const response = await axios.get(`/api/customers?search=${search}&page=${pagination.page}&limit=${pagination.limit}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setCustomers(response.data.data || []);
      setPagination(prev => ({ ...prev, ...(response.data.pagination || {}) }));
    } catch (error) {
      console.error('Fetch customers error:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCreateCustomer = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem('crm_token');
      const res = await axios.post('/api/customers', newCustomer, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const customerId = res.data.id;

      // Upload documents if any selected
      if (selectedFiles.length > 0 && customerId) {
        setUploadingDocs(true);
        const formData = new FormData();
        selectedFiles.forEach(f => formData.append('files', f));
        await axios.post(`/api/customer-docs/${customerId}`, formData, {
          headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data' }
        }).catch(() => {/* evrak hatası müşteri oluşturmayı engellemesin */});
        setUploadingDocs(false);
      }

      setShowModal(false);
      setSelectedFiles([]);
      setNewCustomer({ first_name: '', last_name: '', phone: '', email: '', gender: 'unknown', birth_date: '', city: '', notes: '', source: 'walk_in' });
      fetchCustomers();
    } catch (error) {
      alert('Müşteri eklenemedi');
    }
  };

  const handleFileSelect = (e) => {
    const files = Array.from(e.target.files);
    setSelectedFiles(prev => [...prev, ...files].slice(0, 10));
  };

  const removeFile = (index) => {
    setSelectedFiles(prev => prev.filter((_, i) => i !== index));
  };

  const getTierBadge = (tier) => {
    const colors = {
      bronze: { bg: 'rgba(217, 119, 6, 0.15)', color: '#f59e0b', border: '1px solid rgba(217, 119, 6, 0.3)' },
      silver: { bg: 'rgba(148, 163, 184, 0.15)', color: '#cbd5e1', border: '1px solid rgba(148, 163, 184, 0.3)' },
      gold: { bg: 'rgba(234, 179, 8, 0.15)', color: '#facc15', border: '1px solid rgba(234, 179, 8, 0.3)' },
      platinum: { bg: 'rgba(0, 242, 254, 0.15)', color: '#00f2fe', border: '1px solid rgba(0, 242, 254, 0.3)' }
    };
    const style = colors[tier] || colors.bronze;
    return (
      <span style={{ 
        background: style.bg, 
        color: style.color,
        border: style.border,
        padding: '3px 10px', 
        borderRadius: '6px', 
        fontSize: '11px',
        fontWeight: 600,
        textTransform: 'uppercase'
      }}>
        {tier}
      </span>
    );
  };

  const getSourceBadge = (source) => {
    const sources = {
      walk_in: { icon: '🚶', label: 'Gelip Kayıt' },
      instagram: { icon: '📸', label: 'Instagram' },
      whatsapp: { icon: '💬', label: 'WhatsApp' },
      referral: { icon: '👥', label: 'Tavsiye' },
      web: { icon: '🌐', label: 'Web' },
      phone: { icon: '📞', label: 'Telefon' }
    };
    return sources[source] || sources.walk_in;
  };

  const renderStars = (rating) => {
    if (!rating) return null;
    const rounded = Math.round(Number(rating));
    return (
      <span style={{ color: '#fbbf24', marginLeft: '8px', fontSize: '11px' }} title={`${Number(rating).toFixed(1)} / 5`}>
        {'★'.repeat(rounded)}{'☆'.repeat(5 - rounded)}
      </span>
    );
  };

  if (loading) {
    return (
      <div className="loading">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  return (
    <div>
      <ModuleTour moduleKey="customers" />
      <div className="page-header" data-tour="cust-header">
        <div>
          <h1 className="page-title">Müşteriler</h1>
          <p className="page-subtitle">{pagination.total} kayıtlı müşteri</p>
        </div>
        <button className="btn btn-primary" data-tour="cust-new-btn" onClick={() => setShowModal(true)}>
          <svg viewBox="0 0 20 20" fill="currentColor" width="18" height="18">
            <path fillRule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clipRule="evenodd" />
          </svg>
          Yeni Müşteri
        </button>
      </div>

      <div className="card">
        <div className="search-bar">
          <div className="search-input-wrapper">
            <svg className="search-icon" viewBox="0 0 20 20" fill="currentColor" width="18" height="18">
              <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
            </svg>
            <input
              type="text"
              className="input"
              data-tour="cust-search"
              placeholder="Müşteri ara..."
              value={search}
              onChange={e => setSearch(e.target.value)}
              style={{ paddingLeft: '40px' }}
            />
          </div>
        </div>

        <div className="table-container" data-tour="cust-table">
          <table className="table">
            <thead>
              <tr>
                <th>Müşteri</th>
                <th>İletişim</th>
                <th>Kaynak</th>
                <th>Sadakat</th>
                <th>Son Ziyaret</th>
                <th style={{ width: '100px' }}></th>
              </tr>
            </thead>
            <tbody>
              {(customers || []).map(customer => (
                <tr key={customer.id}>
                  <td>
                    <Link to={`/customers/${customer.id}`} style={{ display: 'flex', alignItems: 'center', gap: '12px', textDecoration: 'none' }}>
                      <div className="avatar" style={{ background: 'linear-gradient(135deg, var(--primary) 0%, var(--secondary) 100%)' }}>
                        {customer.first_name[0]}{customer.last_name?.[0] || ''}
                      </div>
                      <div>
                        <div className="font-medium" style={{ color: 'var(--text)', display: 'flex', alignItems: 'center' }}>
                          {customer.first_name} {customer.last_name}
                          {renderStars(customer.avg_rating)}
                        </div>
                        <div className="text-xs text-muted">{customer.email || '-'}</div>
                      </div>
                    </Link>
                  </td>
                  <td>
                    <div className="text-sm">{customer.phone}</div>
                    <div className="text-xs text-muted">{customer.city || '-'}</div>
                  </td>
                  <td>
                    {(() => {
                      const source = getSourceBadge(customer.source);
                      return (
                        <span className="badge badge-gray">
                          {source.icon} {source.label}
                        </span>
                      );
                    })()}
                  </td>
                  <td>
                    <div className="flex items-center gap-2">
                      {getTierBadge(customer.loyalty_tier)}
                      <span className="text-xs text-muted">{customer.loyalty_points} puan</span>
                    </div>
                  </td>
                  <td>
                    {customer.last_visit_date && !isNaN(new Date(customer.last_visit_date).getTime()) ? (
                      <span className="text-sm">{new Date(customer.last_visit_date).toLocaleDateString('tr-TR')}</span>
                    ) : (
                      <span className="text-muted">-</span>
                    )}
                  </td>
                  <td>
                    <Link to={`/customers/${customer.id}`} className="btn btn-ghost btn-sm">
                      Görüntüle
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {pagination.totalPages > 1 && (
          <div className="flex justify-between items-center mt-4" style={{ padding: '16px 0' }}>
            <div className="text-sm text-muted">
              Sayfa {pagination.page} / {pagination.totalPages}
            </div>
            <div className="flex gap-2">
              <button 
                className="btn btn-secondary btn-sm"
                disabled={pagination.page === 1}
                onClick={() => setPagination(p => ({ ...p, page: p.page - 1 }))}
              >
                Önceki
              </button>
              <button 
                className="btn btn-secondary btn-sm"
                disabled={pagination.page === pagination.totalPages}
                onClick={() => setPagination(p => ({ ...p, page: p.page + 1 }))}
              >
                Sonraki
              </button>
            </div>
          </div>
        )}
      </div>

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: '560px' }}>
            <div className="modal-header">
              <h3 className="modal-title">Yeni Müşteri Ekle</h3>
              <button className="modal-close" onClick={() => setShowModal(false)}>
                <svg viewBox="0 0 20 20" fill="currentColor" width="20" height="20">
                  <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </button>
            </div>

            <form className="modal-body" onSubmit={handleCreateCustomer}>
              <div className="grid grid-2">
                <div className="form-group">
                  <label className="form-label">Ad *</label>
                  <input
                    type="text"
                    className="input"
                    value={newCustomer.first_name}
                    onChange={e => setNewCustomer({ ...newCustomer, first_name: e.target.value })}
                    required
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">Soyad</label>
                  <input
                    type="text"
                    className="input"
                    value={newCustomer.last_name}
                    onChange={e => setNewCustomer({ ...newCustomer, last_name: e.target.value })}
                  />
                </div>
              </div>

              <div className="grid grid-2">
                <div className="form-group">
                  <label className="form-label">Telefon *</label>
                  <input
                    type="tel"
                    className="input"
                    value={newCustomer.phone}
                    onChange={e => setNewCustomer({ ...newCustomer, phone: e.target.value })}
                    required
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">E-posta</label>
                  <input
                    type="email"
                    className="input"
                    value={newCustomer.email}
                    onChange={e => setNewCustomer({ ...newCustomer, email: e.target.value })}
                  />
                </div>
              </div>

              <div className="grid grid-2">
                <div className="form-group">
                  <label className="form-label">Cinsiyet</label>
                  <select
                    className="select"
                    value={newCustomer.gender}
                    onChange={e => setNewCustomer({ ...newCustomer, gender: e.target.value })}
                  >
                    <option value="unknown">Belirtilmemiş</option>
                    <option value="female">Kadın</option>
                    <option value="male">Erkek</option>
                    <option value="other">Diğer</option>
                  </select>
                </div>
                <div className="form-group">
                  <label className="form-label">Doğum Tarihi</label>
                  <input
                    type="date"
                    className="input"
                    value={newCustomer.birth_date}
                    onChange={e => setNewCustomer({ ...newCustomer, birth_date: e.target.value })}
                  />
                </div>
              </div>

              <div className="form-group">
                <label className="form-label">Şehir</label>
                <input
                  type="text"
                  className="input"
                  value={newCustomer.city}
                  onChange={e => setNewCustomer({ ...newCustomer, city: e.target.value })}
                />
              </div>

              <div className="form-group">
                <label className="form-label">Kaynak</label>
                <select
                  className="select"
                  value={newCustomer.source}
                  onChange={e => setNewCustomer({ ...newCustomer, source: e.target.value })}
                >
                  <option value="walk_in">🚶 Gelip Kayıt</option>
                  <option value="instagram">📸 Instagram</option>
                  <option value="whatsapp">💬 WhatsApp</option>
                  <option value="referral">👥 Tavsiye</option>
                  <option value="web">🌐 Web</option>
                  <option value="phone">📞 Telefon</option>
                </select>
              </div>

              <div className="form-group">
                <label className="form-label">Not</label>
                <textarea
                  className="textarea"
                  value={newCustomer.notes}
                  onChange={e => setNewCustomer({ ...newCustomer, notes: e.target.value })}
                  placeholder="Müşteri ile ilgili notlar..."
                  rows={3}
                />
              </div>

              <div className="form-group">
                <label className="form-label">Evrak / Belgeler</label>
                <div
                  onClick={() => fileInputRef.current?.click()}
                  onDragOver={e => { e.preventDefault(); e.currentTarget.style.borderColor = 'var(--primary)'; }}
                  onDragLeave={e => { e.currentTarget.style.borderColor = 'var(--border)'; }}
                  onDrop={e => {
                    e.preventDefault();
                    e.currentTarget.style.borderColor = 'var(--border)';
                    const files = Array.from(e.dataTransfer.files);
                    setSelectedFiles(prev => [...prev, ...files].slice(0, 10));
                  }}
                  style={{ border: '2px dashed var(--border)', borderRadius: 12, padding: '20px 16px', textAlign: 'center', cursor: 'pointer', transition: 'border-color .2s', background: 'rgba(255,255,255,0.02)' }}
                >
                  <div style={{ fontSize: 28, marginBottom: 6 }}>📎</div>
                  <div style={{ color: 'rgba(255,255,255,0.5)', fontSize: 13 }}>Dosyaları buraya sürükleyin veya tıklayın</div>
                  <div style={{ color: 'rgba(255,255,255,0.3)', fontSize: 11, marginTop: 4 }}>Resim (JPG, PNG, WEBP) ve PDF · Maks 20 MB · En fazla 10 dosya</div>
                </div>
                <input ref={fileInputRef} type="file" multiple accept="image/*,.pdf" style={{ display: 'none' }} onChange={handleFileSelect} />
                {selectedFiles.length > 0 && (
                  <div style={{ marginTop: 10, display: 'flex', flexDirection: 'column', gap: 6 }}>
                    {selectedFiles.map((f, i) => (
                      <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 12px', background: 'var(--primary-glow)', border: '1px solid rgba(var(--primary-rgb), 0.2)', borderRadius: 10 }}>
                        <span style={{ fontSize: 18 }}>{f.type === 'application/pdf' ? '📄' : '🖼️'}</span>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--text)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{f.name}</div>
                          <div style={{ fontSize: 11, color: 'var(--text-muted)' }}>{(f.size / 1024).toFixed(0)} KB</div>
                        </div>
                        <button type="button" onClick={() => removeFile(i)} style={{ background: 'none', border: 'none', color: 'var(--danger)', cursor: 'pointer', fontSize: 16, padding: 2 }}>✕</button>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              <div className="modal-footer" style={{ padding: 0, border: 'none', background: 'transparent' }}>
                <button type="button" className="btn btn-secondary" onClick={() => { setShowModal(false); setSelectedFiles([]); }}>
                  İptal
                </button>
                <button type="submit" className="btn btn-primary" disabled={uploadingDocs}>
                  {uploadingDocs ? '⏳ Yükleniyor...' : 'Müşteri Ekle'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default Customers;
